module.exports = "/assets/about/fourth/maciej.png?xhfOJXT";